import React from "react"
import ModalForm from "../../../components/compounds/modalForm/ModalForm.compunds"
import FormContainer from "../../../components/layouts/containers/FormContainer.container"
import FieldContainer from "../../../components/layouts/containers/FieldContainer.container"
import InputRadioButtonForm from "../../../components/molecules/InputRadioButtonForm.molecule"
import MultiSelect from "../../../components/atoms/MultiSelect.atom"
import Divider from "../../../components/atoms/Divider.atom"
import useGroupClientSprints from "../hooks/useGroupClientSprints.hook"
import { CLIENT_REPORT_GROUP_SPRINTS_GROUP_BY } from "../../../consts/modules/clientReport.consts"
import Label from "../../../components/atoms/Label.atom"
import InputTextareaForm from "../../../components/molecules/InputTextareaForm.molecule"

const ModalFormGroupClientSprints = ({
  isModalGroupClientSprintsVisible = false,
  setIsModalGroupClientSprintsVisible = () => {},
  clientSprints = [],
  clientId = null,
  triggerRefresh = () => {},
  sprintBlocks = [],
}) => {
  const {
    formState,
    handleChangeFormState,
    sprintsOptions,
    sprintBlockOptions,
    handleSubmit,
    isSubmitDisabled,
    cleanUpFormState,
  } = useGroupClientSprints({
    clientSprints,
    clientId,
    triggerRefresh,
    sprintBlocks,
  })

  const isGroupByBlock =
    formState.groupBy === CLIENT_REPORT_GROUP_SPRINTS_GROUP_BY.BLOCK

  return (
    <ModalForm
      visible={isModalGroupClientSprintsVisible}
      setVisible={setIsModalGroupClientSprintsVisible}
      service={handleSubmit}
      postSubmit={cleanUpFormState}
      showInlineErrorMessage={false}
      headerTitle="Agrupar periodos"
      headerIconClass="pi pi-table"
      cleanUp={cleanUpFormState}
      closable={false}
      saveLabel="Agrupar"
      disabledSaveBtn={isSubmitDisabled}
    >
      <FormContainer>
        <FieldContainer col={12} md={12} sm={12}>
          <p className="font-weight-700">Tipo de agrupación</p>
        </FieldContainer>
        <FieldContainer col={6} md={6}>
          <InputRadioButtonForm
            label="Bloque"
            name="groupBy"
            value={CLIENT_REPORT_GROUP_SPRINTS_GROUP_BY.BLOCK}
            checked={
              formState.groupBy === CLIENT_REPORT_GROUP_SPRINTS_GROUP_BY.BLOCK
            }
            onChange={() =>
              handleChangeFormState(
                "groupBy",
                CLIENT_REPORT_GROUP_SPRINTS_GROUP_BY.BLOCK
              )
            }
          />
        </FieldContainer>
        <FieldContainer col={6} md={6}>
          <InputRadioButtonForm
            label="Ciclo"
            name="groupBy"
            value={CLIENT_REPORT_GROUP_SPRINTS_GROUP_BY.CYCLE}
            checked={
              formState.groupBy === CLIENT_REPORT_GROUP_SPRINTS_GROUP_BY.CYCLE
            }
            onChange={() =>
              handleChangeFormState(
                "groupBy",
                CLIENT_REPORT_GROUP_SPRINTS_GROUP_BY.CYCLE
              )
            }
          />
        </FieldContainer>
        <FieldContainer col={12} md={12} sm={12}>
          <Divider stroke="sm" className="m-0" />
        </FieldContainer>
        <FieldContainer col={12} md={12} sm={12}>
          <Label htmlFor="selectedData" className="w-fit">
            {isGroupByBlock ? "Sprints" : "Bloques"}
          </Label>
          <MultiSelect
            inputId="selectedData"
            name="selectedData"
            options={isGroupByBlock ? sprintsOptions : sprintBlockOptions}
            optionLabel="name"
            optionValue="id"
            optionDisabled="disabled"
            value={formState.selectedData}
            onChange={(e) => handleChangeFormState("selectedData", e.value)}
            filter
            filterBy="name"
            filterMatchMode="contains"
            showSelectAll={false}
            emptyFilterMessage="Sin resultados"
            placeholder={
              isGroupByBlock ?
                "Selecciona los sprints"
              : "Selecciona los bloques"
            }
            maxSelectedLabels={1}
            selectedItemsLabel={
              isGroupByBlock ?
                "{0} sprints seleccionados"
              : "{0} bloques seleccionados"
            }
          />
          <div className="mt-3">
            <InputTextareaForm
              label="Notas importantes del nuevo periodo"
              name="reportNotes"
              value={formState.reportNotes}
              onChange={(e) =>
                handleChangeFormState("reportNotes", e.target.value)
              }
              rows={5}
              autoResize={false}
              autoTrim={false}
              maxLength={600}
              className="mt-2"
            />
          </div>
        </FieldContainer>
      </FormContainer>
    </ModalForm>
  )
}

export default ModalFormGroupClientSprints
